import React from 'react';
import { SectionsLessonsTab } from '@/features/course-management';
import { adminCourseSectionsService } from '@/features/course-management/services/adminService';
import type { SectionWithLessons } from '@/features/course-management';

interface AdminSectionsLessonsTabProps {
  courseId?: number;
  onUpdate?: (sections: SectionWithLessons[]) => void;
}

const AdminSectionsLessonsTab: React.FC<AdminSectionsLessonsTabProps> = ({ courseId, onUpdate }) => (
  <SectionsLessonsTab
    courseId={courseId}
    onUpdate={onUpdate}
    service={adminCourseSectionsService}
  />
);

export default AdminSectionsLessonsTab;
